import * as React from 'react';
import { Outlet , useNavigate} from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button
 } from '@mui/material';
 
import { Confirmation } from '../utils';
import { CONST } from '../../utils';
import NavigationActions from '../navigationActions';

export default function Holder() {
    document.title = 'Shipping Station';
    const nav = useNavigate();
    
    const HolderContex = {
        empty : undefined
    }

    return(
        <Box>
            <AppBar 
                position="static"
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    SHIPPING LABELER STATION
                </Typography>

                </Toolbar>
            </AppBar>

            <Outlet context={HolderContex}/>
        </Box>
    );
}
